import leaderBoardBG from './LeaderboardLead.jpg'

import avatar from './avatar.png'
import Glowing from './Glowing.png'

export const IMGs = {
    avatar,
    leaderBoardBG,
    Glowing,
}
